/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnteCreateDTO
 */
export interface EnteCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    provinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    comuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    regione?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    provincia?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    comune?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    localita?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    indirizzo?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    numeroCivico?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteCreateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the EnteCreateDTO interface.
 */
export function instanceOfEnteCreateDTO(value: object): value is EnteCreateDTO {
    return true;
}

export function EnteCreateDTOFromJSON(json: any): EnteCreateDTO {
    return EnteCreateDTOFromJSONTyped(json, false);
}

export function EnteCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnteCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'provinciaId': json['provinciaId'] == null ? undefined : json['provinciaId'],
        'comuneId': json['comuneId'] == null ? undefined : json['comuneId'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'regione': json['regione'] == null ? undefined : json['regione'],
        'provincia': json['provincia'] == null ? undefined : json['provincia'],
        'comune': json['comune'] == null ? undefined : json['comune'],
        'localita': json['localita'] == null ? undefined : json['localita'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'numeroCivico': json['numeroCivico'] == null ? undefined : json['numeroCivico'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function EnteCreateDTOToJSON(value?: EnteCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'regioneId': value['regioneId'],
        'provinciaId': value['provinciaId'],
        'comuneId': value['comuneId'],
        'nazioneId': value['nazioneId'],
        'regione': value['regione'],
        'provincia': value['provincia'],
        'comune': value['comune'],
        'localita': value['localita'],
        'indirizzo': value['indirizzo'],
        'numeroCivico': value['numeroCivico'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
    };
}

